// AUTO-GENERATED FILE. DO NOT EDIT.
// Generated by generate-tutorials-manifest CLI from metadata declared in tests/e2e/stories/*.meta.ts

export type TutorialVideo = {
    slug: string;
    category: string;
    title: string;
    description: string;
};

export const TUTORIAL_VIDEOS: TutorialVideo[] = [
    {
        slug: "landing-page-overview",
        category: "Framework",
        title: "Explore the landing page",
        description: "A tour of the Webviz landing page and how to start working from it.",
    },
    {
        slug: "session-and-ensemble-selection",
        category: "Framework",
        title: "Create, save and share a session",
        description: "Start a session, add an ensemble and modules, then save it and share a snapshot.",
    },
    {
        slug: "grid3d-viewer-3d-grid-model",
        category: "Modules",
        title: "3D Viewer",
        description: "Covisualize different 3D data (grid models, seismic slices, well trajectories, surfaces...).",
    },
    {
        slug: "flow-network-module",
        category: "Modules",
        title: "Flow Network",
        description: "The Flow Network module visualizes the reservoir simulator's network tree as it evolves over time, along with the oil, gas, and water flowing through each branch.",
    },
    {
        slug: "simulation-time-series-chart",
        category: "Modules",
        title: "Simulation Time Series",
        description: "Visualize simulated time series data, together with observations used in the assisted history matching process",
    },
];
